import { POST_SUCCESS } from 'modules/appointments/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../actionTypes';

const initialState = {
  isOpen: false,
  props: {},
};

const openModal = (state, { payload }) => ({
  ...state,
  isOpen: true,
  props: payload,
});

const closeModal = state => ({
  ...state,
  isOpen: false,
});

const createAppointmentSuccess = state => ({
  ...state,
  isOpen: false,
});

export default createReducer(initialState, {
  [actionTypes.OPEN_CREATE_NEW_APPOINTMENT_MODAL]: openModal,
  [actionTypes.CLOSE_CREATE_NEW_APPOINTMENT_MODAL]: closeModal,
  [POST_SUCCESS]: createAppointmentSuccess,
});
